<template>
  <div class="body-container">
    <v-card class="custom-card">
      <v-form ref="formFindOTP" v-model="formValid" lazy-validation>
        <div class="pt-3">
          <h3 class="form-title">FIND USER WESERVE OTP</h3>
          <div class="layout-input">
            <v-layout row wrap>
              <v-flex md9>
                <v-text-field
                  :rules="[telValid.required, telValid.leng]"
                  label="User tel."
                  type="number"
                  v-model="userTel"
                  class="pt-2 pb-2 custom-input"
                ></v-text-field>
              </v-flex>
              <v-flex md3>
                <v-btn
                  :loading="isSearching"
                  :disabled="isSearching"
                  @click="searchOTP()"
                >
                  <v-icon>search</v-icon>Search
                </v-btn>
                <v-btn :disabled="isSearching" @click="resetForm()"
                  >Reset</v-btn
                >
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-form>
      <div class="pt-3 layout-content" v-if="showUserTel">
        <v-layout row wrap align-center>
          <span class="title-content pr-2"
            >Recently OTP {{ showUserTel }} by is :</span
          >
          <div
            class="pr-2 OTP-text"
            :style="{
              color: resultOTP == 'NO OTP AVAILABLE' ? 'red' : '#4caf50',
            }"
          >
            {{ resultOTP }}
          </div>
        </v-layout>
      </div>
    </v-card>
    <v-card class="custom-card mt-5">
      <v-form ref="formFindOTPMerchant" v-model="formValidMC" lazy-validation>
        <div class="pt-3">
          <h3 class="form-title">FIND USER Merchant OTP</h3>
          <div class="layout-input">
            <v-layout row wrap>
              <v-flex md9>
                <v-text-field
                  :rules="[telValid.required, telValid.leng]"
                  label="User tel."
                  type="number"
                  v-model="userMerchantTel"
                  class="pt-2 pb-2 custom-input"
                ></v-text-field>
              </v-flex>
              <v-flex md3>
                <v-btn
                  :loading="isSearchingMC"
                  :disabled="isSearchingMC"
                  @click="searchOTPMerchant()"
                >
                  <v-icon>search</v-icon>Search
                </v-btn>
                <v-btn :disabled="isSearchingMC" @click="resetFormMC()"
                  >Reset</v-btn
                >
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-form>
      <div class="pt-3 layout-content" v-if="showUserTelMC">
        <v-layout row wrap align-center>
          <span class="title-content pr-2"
            >Recently OTP {{ showUserTelMC }} by is :</span
          >
          <div
            class="pr-2 OTP-text"
            :style="{
              color: resultOTPMC == 'NO OTP AVAILABLE' ? 'red' : '#4caf50',
            }"
          >
            {{ resultOTPMC }}
          </div>
        </v-layout>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      userMerchantTel: "",
      formValidMC: true,
      isSearchingMC: false,
      userTel: "",
      showUserTel: "",
      showUserTelMC: "",
      resultOTP: "",
      resultOTPMC: "",
      formValid: true,
      isSearching: false,
      telValid: {
        required: (value) => !!value || "Required.",
        leng: (v) => v.length == 10 || "10 characters",
      },
    };
  },
  methods: {
    ...mapActions({
      fetchUserOTP: "fetchCustomerBack/fetchUserOTP",
      fetchUserOTPMerchant: "fetchCustomerBack/fetchUserOTPMerchant",
    }),
    async searchOTPMerchant() {
      if (this.$refs.formFindOTPMerchant.validate()) {
        this.isSearchingMC = true;
        let response = await this.fetchUserOTPMerchant(this.userMerchantTel);
        this.isSearchingMC = false;
        if (response == false) return;
        let availableOTP = response.filter((val) => val.sms_verified == false);
        if (availableOTP.length == 0) {
          this.resultOTPMC = "NO OTP AVAILABLE";
        } else {
          this.resultOTPMC = availableOTP[availableOTP.length-1].sms_pin;
        }

        this.showUserTelMC = this.userMerchantTel;
      }
    },
    async searchOTP() {
      if (this.$refs.formFindOTP.validate()) {
        this.isSearching = true;
        this.resultOTP = await this.fetchUserOTP(this.userTel);
        if (this.resultOTP != false) {
          this.showUserTel = this.userTel;
        }
        this.isSearching = false;
      }
    },
    resetForm() {
      this.userTel = "";
      this.$refs.formFindOTP.resetValidation();
    },
    resetFormMC() {
      this.userMerchantTel = "";
      this.$refs.formFindOTPMerchant.resetValidation();
    },
  },
};
</script>

<style  scoped>
.layout-content {
  display: flex;
  align-items: center;
}

.OTP-text {
  font-size: 30px;
  text-decoration: underline;
  font-weight: 600;
}
.form-title {
  text-align: center;
  font-size: 24px;
  white-space: nowrap;
}

.custom-card {
  padding: 20px;
}

.title-content {
  font-size: 18px;
  font-weight: 600;
}

.layout-input {
  display: flex;
}

@media screen and (max-width: 768px) {
  .custom-card {
    width: 100%;
  }

  .title-content {
    font-size: 12px;
  }
  .OTP-text {
    font-size: 24px;
  }
}
</style>